<template>
	<div class="d-flex justify-end align-center" v-if="['BudgetContractSerialsTable'].includes($route.name)">
		<v-tooltip bottom v-if="editPermission">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					fab
					dark
					x-small
					color="#FF120B"
					class="mx-1"
					@click="setReportModal"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon small dark>mdi-file-document-outline</v-icon>
				</v-btn>
			</template>
			<span>Preparar Nuevo Informe</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					fab
					dark
					x-small
					color="#FF120B"
					class="mx-1"
					@click="newBudget"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon small dark>mdi-book-outline</v-icon>
				</v-btn>
			</template>
			<span>Preparar Nuevo Presupuesto</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					fab
					dark
					x-small
					color="#FF120B"
					class="mx-1"
					@click="newContract"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon small dark>mdi-briefcase-outline</v-icon>
				</v-btn>
			</template>
			<span>Preparar Nuevo Contrato</span>
		</v-tooltip>
	</div>
</template>

<script>
export default {
	name: 'SerialTableButtons',
	components: {  },
	computed: {
		editPermission(){
			return this.$checkPermissions(['edit_preprojects'])
		}
	},
	data: () => ({
		fab: false
	}),
	mounted(){
	},
	methods: {
		openNewProjectModal(doc_type){
			const pre_project = {...{doc_type}}
			this.$store.commit('projects/setProjectModalInfo', pre_project)
			this.$store.commit('projects/setProjectModal', true)
		},
		newBudget(){
			this.$store.commit('budget/setModalNewBudget', true)
		},
		newContract(){
			this.$store.commit('contracts/setModalContract', true)
		},
		setReportModal(){
			const data = {
				item_type: 'crm'
			}
			this.$store.commit('reports/setConfirmNewReportModal', data)
		}
	}
};
</script>